// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import type { IRuntimeConfig as Plugin0 } from '/var/www/morellato-oms-ui/src/.umi/plugin-antd/runtimeConfig.d'
import type { IRuntimeConfig as Plugin1 } from '/var/www/morellato-oms-ui/src/.umi/plugin-dva/runtimeConfig.d'
import type { IRuntimeConfig as Plugin2 } from '/var/www/morellato-oms-ui/src/.umi/plugin-initialState/runtimeConfig.d'
import type { IRuntimeConfig as Plugin3 } from '/var/www/morellato-oms-ui/src/.umi/plugin-layout/runtimeConfig.d'
import type { IRuntimeConfig as Plugin4 } from '/var/www/morellato-oms-ui/src/.umi/plugin-locale/runtimeConfig.d'
import type { IRuntimeConfig as Plugin5 } from '/var/www/morellato-oms-ui/src/.umi/plugin-request/runtimeConfig.d'
interface IDefaultRuntimeConfig {
  onRouteChange?: (props: { routes: any, clientRoutes: any, location: any, action: any, isFirst: boolean }) => void;
  patchRoutes?: (props: { routes: any }) => void;
  patchClientRoutes?: (props: { routes: any }) => void;
  render?: (oldRender: () => void) => void;
  rootContainer?: (lastRootContainer: JSX.Element, args?: any) => void;
  [key: string]: any;
}
export type RuntimeConfig = IDefaultRuntimeConfig & Plugin0 & Plugin1 & Plugin2 & Plugin3 & Plugin4 & Plugin5

export function defineApp(config: RuntimeConfig): RuntimeConfig {
  return config;
}
